// extracted by mini-css-extract-plugin
export var button__primary = "styles-module--button__primary--c7a2b";
export var col1 = "styles-module--col1--b5754";
export var col2 = "styles-module--col2--6de39";
export var col3 = "styles-module--col3--7fa0f";
export var container = "styles-module--container--06929";
export var cursor = "styles-module--cursor--62bb8";
export var cursorFollower = "styles-module--cursor-follower--c8e45";
export var emailField = "styles-module--email-field--bf99a";
export var errMessage = "styles-module--err-message--f82ca";
export var errored = "styles-module--errored--539c5";
export var headingCentered = "styles-module--heading-centered--0f9d8";
export var icon = "styles-module--icon--7239f";
export var noScroll = "styles-module--no-scroll--a4c95";
export var pageTemplatePageGame = "styles-module--page-template-page-game--ac663";
export var registered = "styles-module--registered--e8a03";
export var section__wrapper = "styles-module--section__wrapper--b4ab7";
export var section__wrapperLarge = "styles-module--section__wrapper--large--55ae4";
export var sending = "styles-module--sending--93660";
export var submit = "styles-module--submit--2df45";
export var submitDisabled = "styles-module--submit-disabled--267ff";
export var title = "styles-module--title--04d3d";
export var wrapper = "styles-module--wrapper--c1ba6";